import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WhyMe from "@/components/WhyMe";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import Tools from "@/components/Tools";
import Education from "@/components/Education";
import Experience from "@/components/Experience";
import Organizational from "@/components/Organizational";
import Events from "@/components/Events";
import Portfolio from "@/components/Portfolio";
import Skills from "@/components/Skills";
import Awards from "@/components/Awards";
import Contact from "@/components/Contact";
import WhatsAppButton from "@/components/WhatsAppButton";
import SplineBackground from "@/components/SplineBackground";

const Index = () => {
  useScrollReveal();

  return (
    <div className="min-h-screen relative">
      <SplineBackground />
      <div className="relative z-10">
        <Navbar />
        <Hero />
        <WhyMe />
        <Tools />
        <Experience />
        <Portfolio />
        <Education />
        <Organizational />
        <Events />
        <Skills />
        <Awards />
        <Contact />
        <WhatsAppButton />
      </div>
    </div>
  );
};

export default Index;
